






























































































import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, PropType, computed, toRef } from '@vue/composition-api';

import { LayoutFieldItem } from '../model/layout';
import { VISIBLE_FIELDS, UN_REQUIRED_FIELDS, CAN_EDIT_FIELDS } from '../common/config';
import { TYPE_ICONS, FIELD_ICONS } from '../common/iconType';
import { useGetter } from 'common-module/src/util/useVuex';
import { useFieldLayout } from '../store';
import * as permission from 'common-module/src/config/permission';

export default defineComponent({
  name: 'TheFieldCard',
  components: {},
  props: {
    fieldInfo: {
      type: Object as PropType<LayoutFieldItem>,
      default: () => ({})
    },
    used: {
      type: Boolean,
      default: false
    },
    isFixed: {
      type: Boolean,
      default: false
    },
    isDragFixed: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const store = useFieldLayout();
    const isOrgFieldPermission = computed(()=> useGetter('user/checkAccessPermission')?.(permission.systemFieldMgr));

    const fieldIcon = computed(() => {
      return (
        FIELD_ICONS[props.fieldInfo.fieldCode] ||
        TYPE_ICONS[props.fieldInfo.controlCode as string]
      );
    });
    // 是否为组织字段
    const isOrgField = computed(() => !props.fieldInfo.fieldProjectId);
    // 是否为系统字段
    const isSystemField = computed<boolean>(() => props.fieldInfo.source === 'system');
    // 是否显示删除字段按钮
    const showDelete = computed(() => !props.used && !isOrgField.value);
    // 该字段是否能编辑or是否有编辑权限
    const hasPermission = computed<boolean>(() =>
      isOrgField.value
        ? (isOrgFieldPermission.value && (
          !isSystemField.value || CAN_EDIT_FIELDS.includes(props.fieldInfo.fieldCode)
        ))
        : true
    );
    // 是否显示无权限编辑提示
    const showNoPromiseTips = computed<boolean>(
      () => isOrgField.value &&
        !isOrgFieldPermission.value &&
        (isSystemField.value ? CAN_EDIT_FIELDS.includes(props.fieldInfo.fieldCode) : true)
    );

    const fixedVisible = computed(() => VISIBLE_FIELDS.includes(props.fieldInfo?.fieldCode));
    const visibleIcon = computed(() => props.fieldInfo.showed ? 'zkicon iconxianshi' : 'zkicon iconyincang');

    const showRequired = computed(() => props.fieldInfo.showed && props.used && !UN_REQUIRED_FIELDS.includes(props.fieldInfo.fieldCode));
    const isRequired = computed({
      get: () => props.fieldInfo.requiredFlag === 1,
      set: (event) => {
        emit('required-change', event, props.fieldInfo);
      }
    });
    const requiredDisabled = computed(() => props.fieldInfo.couldModifyRequired === 0);

    // const isFixed = computed(() => FIXED_FIELDS.includes(props.fieldInfo.fieldCode));
    const showRemove = computed(() => !props.isFixed && !props.isDragFixed && props.used);

    const onCardClick = () => {
      if (!hasPermission.value) {
        return;
      }
      return isOrgField.value ? emit('view', props.fieldInfo) : emit('edit', props.fieldInfo);
    };

    const deleteLoading = computed(() => store.deleteLoading || store.checkDeleteLoading);

    return {
      showRequired,
      fieldIcon,
      isOrgField,
      showDelete,
      fixedVisible,
      visibleIcon,
      isRequired,
      requiredDisabled,
      showRemove,
      hasPermission,
      showNoPromiseTips,
      deleteLoading,
      onCardClick
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
